// GENERATED FILE — do not edit by hand.
// Rendered from environment.template.ts + values/dev.env by scripts/render-env.js.
// Edit those sources instead, then re-run `npm run gen:env -- dev`.

// SINGLE SOURCE OF TRUTH for the Angular environment config.
//
// This file is a TEMPLATE. The deploy workflow (.github/workflows/deploy.yml)
// renders it into `src/environments/environment.ts` at build time by substituting
// the ${APP_*} placeholders with the values from `src/environments/values/<env>.env`.
//
// To change a value for a deployed environment, edit the matching
// `src/environments/values/<env>.env` file — NOT the generated environment.ts.
// To change the SHAPE (add/remove a key), edit this template.
//
// Every *Service URL is derived from https://api.socommerz.in, so a host change is one edit.

export const environment = {
  apiBaseUrl: 'https://api.socommerz.in',
  domain: 'socommerz.in',
  appVersion: '1.0.0',
  appName: 'Socommerz Admin',
  name: 'dev',
  buildNumber: '20260218',
  production: false,
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  skipAuthDomains: ['api.postalpincode.in'],
  userService: 'https://api.socommerz.in/user-service/api',
  productService: 'https://api.socommerz.in/product-service/api',
  orderService: 'https://api.socommerz.in/order-service/api',
  offerService: 'https://api.socommerz.in/offer-service/api',
  inventoryService: 'https://api.socommerz.in/inventory-service/api',
  imageService: 'https://api.socommerz.in/image-service/api',
  customerService: 'https://api.socommerz.in/customer-service/api',
  integrationService: 'https://api.socommerz.in/integrations-service/api',
  // Blank import templates. Deliberately NOT derived from APP_API_BASE_URL: they
  // are objects in each environment's own bucket, and the bucket host differs from
  // the API host. These were hardcoded to the DEV bucket in every environment, so
  // prod admin served its import templates out of dev.
  sampleTemplatesBaseUrl: 'https://minio.socommerz.in/b2c/samples',

  // --- Media CDN rewrite (see core/utils/to-cdn-url.ts) ---
  // Host that serves mirrored public media, e.g. 'https://cdn.unicornstore.app'.
  // BOTH of these must be non-empty for the rewrite to do anything, so leaving
  // either blank ships it dark. Only set them once the objects have actually been
  // mirrored — pointing at a host that lacks the keys turns every image into a 404.
  mediaCdnBaseUrl: '',
  // Comma-separated origins whose objects are known to exist on the CDN.
  mediaLegacyBaseUrls: '',
  reviewService: 'https://api.socommerz.in/review-service/api',
  scapperService: 'https://crawl-api.socommerz.in/scrapper-api',
  ownerId: '64ccdd2cc0fac3e1d525e5d0',
  superAdminId: '64f6f00eb7de64ba20b09893',
  previewShop: 'https://socommerz.in',
  baseDomain: 'socommerz.in',
  // M2B connect page, for the "Back to M2B" button on Plugins › Connected apps (empty = hidden).
  m2bAppUrl: '',
  webSocketUrl: 'https://api.socommerz.in',
  googleMapsApiKey: 'AIzaSyCnKMqvr1bEowcQ8sdykd2OeVPbvabhWis',

  // Fallback currency when the active shop has none. Symbol/locale lookup
  // lives in `src/app/constants/countryCurrencyData.ts`.
  defaultCurrency: 'INR',

  // Real user monitoring into the platform's own stack (Alloy -> Loki ->

  // Grafana). Leave `url` empty to disable — with no url the SDK is never

  // even downloaded. Prefer this over the openobserve block below; running

  // both means two beacon streams and two places to look.

  faro: {

    url: '',

    sampleRate: 1

  },

  openobserve: {
    enabled: true,
    clientToken: 'rumMZhrW60PpW1SCMMt',
    applicationId: 'socommerz-admin',
    site: 'oos.socommerz.in',
    organizationIdentifier: 'default',
    service: 'socommerz-admin',
    environment: 'dev',
    apiVersion: 'v1',
    insecureHTTP: false,
    // % of sessions tracked by RUM (perf/errors/actions).
    sessionSampleRate: 100,
    // % of tracked sessions recorded for Session Replay.
    sessionReplaySampleRate: 50,
    // 'allow' | 'mask-user-input' | 'mask'. Inputs are masked unless 'allow'.
    defaultPrivacyLevel: 'allow' as 'allow' | 'mask-user-input' | 'mask'
  }
};
